import EtablissementFcap from '@/generated/controls/etablissement/EtablissementFcap.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: EtablissementFcap
})
